import React from "react";
import Layout from "../../components/Layout/Layout";
import Feedback from "../../components/general/Feedback/Feedback";
import Info from "../../components/pages/DeliveryAndPayment/Info/Info";
import DeliveryCost from "../../components/pages/DeliveryAndPayment/DeliveryCost/DeliveryCost";

const DeliveryAndPaymentPage: React.FC = () => {
  return (
    <Layout>
      <Info />
      <DeliveryCost />
      <Feedback />
    </Layout>
  );
};

export default DeliveryAndPaymentPage;
